import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsTable from "./en-us/table.json";
import localizationEnUsFilter from "./en-us/filter.json";

export const localizationEnUsInvoices = {
  ...localizationEnUsHeader,
  ...localizationEnUsTable,
  ...localizationEnUsFilter,
};
